import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ModularGoogleAnalyticsService } from '../../services/modular-google-analytics.service';

@Component({
  selector: 'app-internal-external-switch',
  templateUrl: './internal-external-switch.component.html',
  styleUrls: ['./internal-external-switch.component.scss'],
})
export class InternalExternalSwitchComponent implements OnInit {
  wallsHidden = false;

  constructor(
    private configurationService: ConfigurationService,
    private googleAnalyticsService: ModularGoogleAnalyticsService
  ) {}

  ngOnInit() {
    this.configurationService.hideFrontWallsChanged$.subscribe(hidden => {
      this.wallsHidden = hidden;
    });
  }

  toggleInternal(internal: boolean) {
    this.googleAnalyticsService.sendEvent('internalExternalSwitch', internal ? 'Internal' : 'External');
    this.wallsHidden = internal;
    this.configurationService.setHideFrontWalls(internal);
  }
}
